import { AbstractControl, FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';

export function preventDuplication(formArray: FormArray, index: number, keysToBeChecked: string[]): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value) {
        const { current, oldValue } = keysToBeChecked.reduce(
          (accumulator, name) => {
            accumulator.current[name] = control.value[name];
            accumulator.oldValue[name] = formArray.value[index]?.[name];
            return accumulator;
          },
          { current: {}, oldValue: {} } as any
        );

        let exist = false;
        formArray.controls?.forEach((c, i) => {
          let item = {};
          if (i !== index) {
            item = keysToBeChecked.reduce((accumulator, name) => {
              accumulator[name] = c.value[name];
              return accumulator;
            }, {} as any);
          }
          if (JSON.stringify(item) === JSON.stringify(current)) {
            exist = true;
          } else if (JSON.stringify(item) === JSON.stringify(oldValue)) {
            Promise.resolve().then(() => formArray.controls[i].updateValueAndValidity({ onlySelf: true, emitEvent: false }));
          }
        });

        if (exist) {
          return {
            isDuplicatedItem: true,
          };
        }
        return null;
      }
    };
  }
